import { Inject, inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
class AuthGuard{
  constructor(
    private toastr: ToastrService,
    private Auth: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId:Object
  ) { }
  
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {

    if(isPlatformBrowser(this.platformId)){
      if (!localStorage.getItem('token')) {
        this.toastr.error(
          $localize`Sesión expirada, por favor inicie sesión nuevamente`
        );
        console.log(state.url)
        this.router.navigate(['/login/.'], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }

      const isTokenValid = await lastValueFrom(this.Auth.verifyToken())
        .then(() => {
          if (route.data.unAllowedUsers) {
            if (!this.Auth.userIsUser()) return true;
            this.toastr.error($localize`Esta ruta es inaccesible`);
            this.router.navigate(['/platform/.']);
          }
          return true;
        })
        .catch(() => {
          this.toastr.error(
            $localize`Sesión expirada, por favor inicie sesión nuevamente`
          );
          this.router.navigate(['/login/.'], {
            queryParams: { returnUrl: state.url },
          });
          return false;
        });
      return isTokenValid;
    }else return false;
  }
}

  export const isAuthenticated: CanActivateFn = (route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot): Promise<boolean> => {
    return inject(AuthGuard).canActivate(route,state);
  }